import React from "react";
export function TickSVG() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8L6.54421 11.4082C7.36949 12.0271 8.53016 11.9168 9.22409 11.1535L18 1.5" stroke="white"
            strokeWidth="4" />
    </svg>
  );
}